export { default } from './BlueIconWrapper';



// WEBPACK FOOTER //
// ./src/components/atoms/BlueIconWrapper/index.js